export interface ResolveProfilePhotoPictureStateParams {
  profilePictureUrl?: string | null;
  userId?: string;
  hasProfilePicture?: boolean;
  /** When false, skip thumbnail fetch (portal requires businessId). Default true. */
  fetchEnabled?: boolean;
  inlinePictureFailed: boolean;
  fetchedPicture?: string | null;
}

export interface ResolveProfilePhotoPictureStateResult {
  shouldFetchPicture: boolean;
  picture: string | undefined;
}

/**
 * Pure orchestration for ProfilePhoto wrappers — fetch gate, resolved URL, and inline-failure handler.
 */
export function resolveProfilePhotoPictureState(
  params: ResolveProfilePhotoPictureStateParams
): ResolveProfilePhotoPictureStateResult {
  const fetchEnabled = params.fetchEnabled !== false;
  const shouldFetchPicture =
    fetchEnabled &&
    !!params.userId &&
    !!params.hasProfilePicture &&
    (!params.profilePictureUrl || params.inlinePictureFailed);

  const picture = params.inlinePictureFailed
    ? (params.fetchedPicture ?? undefined)
    : (params.profilePictureUrl ?? params.fetchedPicture ?? undefined);

  return { shouldFetchPicture, picture };
}

export function resolveProfilePhotoSurfaceSeed(params: {
  userId?: string;
  name?: string;
  firstName?: string;
}): string {
  return params.userId?.trim() || params.name?.trim() || params.firstName?.trim() || '';
}

export function createProfilePhotoPictureFailedHandler(params: {
  profilePictureUrl?: string | null;
  inlinePictureFailed: boolean;
  setInlinePictureFailed: (failed: boolean) => void;
  onPictureFailed?: () => void;
}): () => void {
  return () => {
    if (params.profilePictureUrl && !params.inlinePictureFailed) {
      params.setInlinePictureFailed(true);
    }
    params.onPictureFailed?.();
  };
}
